(function($){
    // animate scroll
    $('a.linkTo[href*="#"], a.nav-link[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 2000, function() {
                    var $target = $(target);
                    $target.focus();

                    if ($target.is(":focus")) {
                        return false;
                    } else {
                        $target.attr('tabindex','-1');
                        $target.focus();
                    };
                });
            }
        }
    }); 

    // let burgerIn_1 = $("#burger-1");
    let burger = $(".burger");
    let burgerClose = $("#burgerClose");
    let navMenu = $('#navMenu');
    let navList = $('#navMenu .navContent .item')
    // let verticalNav = $('.verticalNav .list');
    
    $(burger).unbind().click(function(){
        $(navMenu).toggleClass('active');
        $('body').toggleClass('modal-open');
    })
    
    $(navList).on('click', function(){
        navMenu.toggleClass('active');
        $('body').removeClass('modal-open');
        navList.siblings().removeClass('active');
        $(this).addClass('active');
    })

    $(burgerClose).on('click', function(){
        $(navMenu).toggleClass('active');
        $('body').removeClass('modal-open');
    }) 

    // slick slide --------------------
    $('.slideContent').slick({
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        dots: false
    });

    // Custom carousel nav
    $('.carousel-prev').click(function(){ 
        $('.carousel-nav').parent().find('.slideContent').slick('slickPrev');
    } );

    $('.carousel-next').click(function(e){
        e.preventDefault(); 
        $('.carousel-nav').parent().find('.slideContent').slick('slickNext');
    } ); 

     // wine Sheet
     $(".contentOverflow").mCustomScrollbar({
        theme: 'rounded-dark',
        scrollButtons:{enable: true},
        scrollbarPosition: 'outside',
    }); 
    
    // lazysizes - add simple support for background images
    document.addEventListener('lazybeforeunveil', function (e) {
        var bg = e.target.getAttribute('data-bg');
        if (bg) {
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });
    
})(jQuery);